import React from 'react'
import PropTypes from 'prop-types'
import { FormControl } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import SettingsCard from '../../../components/Settings/SettingsCard'

export default function CommunityMessageCard({
  value,
  onChange,
  onSave,
  hasChanged,
  isSaving,
}) {
  const { t } = useTranslation()

  return (
    <SettingsCard
      icon="comment-smile"
      title={t(
        'business.edit.community_message_title',
        'Business Community Message',
      )}
      description={t(
        'business.edit.community_message_description',
        'Share a message about your business and community involvement.',
      )}
      actions={
        <button
          className="btn btn-primary"
          type="button"
          onClick={onSave}
          disabled={!hasChanged || isSaving}
        >
          {isSaving
            ? t('users.edit.saving', 'Saving...')
            : t('business.edit.save')}
        </button>
      }
    >
      <FormControl
        as="textarea"
        rows={5}
        value={value || ''}
        onChange={e => onChange(e.target.value)}
        placeholder={t(
          'business.edit.community_message_placeholder',
          'Enter your business community message...',
        )}
      />
    </SettingsCard>
  )
}

CommunityMessageCard.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  hasChanged: PropTypes.bool,
  isSaving: PropTypes.bool,
}
